import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import React, { useEffect } from "react";
import ErrorComponent from "../../../components/ErrorComponent";
import { MetaTagsComp } from "../../../components/MetaTagsComp";
import StudyAbroadScholarshipCountryComponent from "../../../components/StudyAbroad/ScholarshipCountryComponent";
import fetchUtil from "../../../utils/fetchUtil";
import { CACHE_REVALIDATE_24H } from '../../../utils/constants';
import CountrySpecificScholarship from "../../../components/ScholarshipsPage/CountrySpecificScholarship/CountrySpecificScholarship";

const ScholarshipCountry: NextPage = (props: any) => {
  if (!props.pageData || props.pageData.length === 0) {
    return <ErrorComponent />;
  }

  const { meta } = props.pageData?.[0];
  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty("--navbar-color", "#6c48f0");
    customStyle.setProperty("--navbar-menu-color", "#FFFFFF");
  }, []);

  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
     {props.mode === 'newUI' ? <CountrySpecificScholarship {...props} /> : <StudyAbroadScholarshipCountryComponent {...props}/>}
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: 'blocking' };
}

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData: any = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/country-specific-scholarships?slug=${context.params?.slug}`, 'GET', {}, '', false)
  const pageDataNewUI  = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/new-country-specific-scholarships?slug=${context.params?.slug}`, 'GET', {}, '', false)
  const newUIEnabled = pageData?.[0]?.showNewUI ?? false;

  if(newUIEnabled) {
    return {
      props: {
        pageData: pageDataNewUI,
        mode: 'newUI'
    },
    revalidate: CACHE_REVALIDATE_24H,
    }
  }

  return {
      props: {
          pageData,
          mode: 'oldUI'
      },
      revalidate: CACHE_REVALIDATE_24H,
  };
};

export default ScholarshipCountry;
